'use client';
/**
 * 광고가 붙는 모든 자리의 작은 「광고하기」 글자 링크(Node 요청 10/27 — «작게나마라도»).
 *   href = /advertise?from=<지면> · rel="nofollow" · 클릭 → advertise_click(from) — 기존 계측 경로(trackAdvertiseClick).
 *   12px · 줄 높이 18px(«광고» 칩과 같은 줄) — 머리줄 높이를 바꾸지 않는다(CLS 0). 서버 HTML 에 그대로 있다(모든 UA 같은 HTML).
 *   광고 클릭(ad_click)으로 세지 않는다 — data-paid-ad-link 없음.
 */
import React from 'react';
import { trackAdvertiseClick } from './track';
import './advertise-mini.css';

const FROM_RE = /^[a-z0-9_]{1,30}$/;

export const advertiseMiniHref = (from: string): string => `/advertise?from=${FROM_RE.test(from) ? from : 'ad_slot'}`;

export default function AdvertiseMiniLink({ from, className }: { from: string; className?: string }) {
  const f = FROM_RE.test(from) ? from : 'ad_slot';
  return (
    <a
      className={`kd-adv-mini${className ? ` ${className}` : ''}`}
      href={advertiseMiniHref(f)}
      rel="nofollow"
      data-advertise-link={f}
      onClick={() => trackAdvertiseClick(f)}
    >
      광고하기
    </a>
  );
}
